module.exports = __webpack_public_path__ + "static/media/audioml2.a39a102e.jpg";